import React, { Component } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import * as actions from '../../actions/ordersAction';
import * as symbols from '../../operations/symbols';
import { getBase64 } from '../../operations/operations';
import LoaderComponent from '../core/LoaderComponent';


class IssueConfirmedModal extends Component {

  render() {
    const { isOpen, reasonsList, reasonId } = this.props;
    const isOrderCancelled = reasonsList && reasonsList[reasonId] === "Duplicate order" ? true : false;
    if (isOpen) {
      return (
        <div className="modal">
          <div className="modal-overlay modal-picture">
            <div className="modal-title align-left">
               {isOrderCancelled ? 'Delivery Cancelled.' : 'Re-attempt Delivery Later' } 
            </div>
            <div className="light-line" />
               <div className="modal-body align-left">
                <div className="flex">
                  <img src="../../../../../images/orderbag.png" />
                  {isOrderCancelled ? 
                    <span className="ml-1"> We have sent your message to inform the Hyperpure team that you <b>can't deliver</b> this order</span>:
                    <span className="ml-1"> We have sent your message to inform the Hyperpure team that you <b>will re-attempt delivery</b> of this order</span>
                  }
              </div>
              <div className="btn btn-green btn-expand mt-2 mb-1" onClick={() => this.props.history.push('/')}>Go back to orders</div>
            </div>
          </div>
        </div>
      )
    }
    return null
  }
}

export default IssueConfirmedModal;
